import React from "react";
import { withWalletContainer } from "../../containers/gamification2026";
import WalletLayout from "./WalletLayout";
import WalletPills from "./WalletPills";
import WalletFilters from "./WalletFilters";
import WalletTable from "./WalletTable";

const Wallet = (props) => {
  const {
    walletItems,
    walletPills,
    walletFilters,
    walletPagination,
    onFilterChange,
    onPillChange,
    onPageChange,
    onViewDetails,
  } = props;

  return (
    <WalletLayout>
      <WalletPills
        pills={walletPills}
        activeType={walletFilters.type}
        onPillChange={onPillChange}
      />
      <WalletFilters
        filters={walletFilters}
        pills={walletPills}
        onFilterChange={onFilterChange}
      />
      <WalletTable
        items={walletItems}
        pagination={walletPagination}
        page={walletPagination.currentPage}
        onPageChange={onPageChange}
        onViewDetails={onViewDetails}
      />
    </WalletLayout>
  );
};

export default withWalletContainer(Wallet);
